import React from "react";
import { Link } from "gatsby";
import useBrowserMode from '../../../shared/hooks/useBrowserMode';

import "./recommendationCard.scss";

const RecommendationCard = (props: any) => {

    const {window} = useBrowserMode();

    const data = props.referenciaInterna.referenciaContenido[0].referenciaMultimedia[0];
    const baseUrl = window.location.href.slice(-1) != "/" ?  window.location.href : window.location.href.slice(0, -1);
    let slicedUrl = baseUrl.split("/");
    slicedUrl.pop();
    const completeUrl = slicedUrl.join("/") +"/"+ props.slug;   
    
    return (
        <Link to={completeUrl}>
            <div className="m-recommendation-card">
                <div className="m-recommendation-card__img-section">
                    {data.imagenPrincipal && (
                        <img src={data.imagenPrincipal.file.url} alt={data.tituloMultimedia}/>
                    )}
                </div>
                <div className="m-recommendation-card__text-section">
                    <span>
                        {data.tematica}
                    </span>
                    <h1>
                        {data.tituloMultimedia}
                    </h1>
                </div>
            </div>
        </Link>
    );
}

export default RecommendationCard;